import type { TStyleSheet } from '~/types/emotion-styles';

const styles: TStyleSheet = {
  container: {
    position: 'relative',
    display: 'inline-block',
    width: '60px',
    height: '34px',
  },
  input: {
    opacity: 0,
    width: 0,
    height: 0,
  },
  sliderOff: {
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#ccc',
    transition: '0.4s',
    borderRadius: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: '12px',
    paddingRight: '5px',
    '&:before': {
      content: "''",
      position: 'absolute',
      height: '26px',
      width: '26px',
      left: '4px',
      bottom: '4px',
      backgroundColor: 'white',
      transition: '0.4s',
      borderRadius: '30px',
    },
  },
  sliderOn: {
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#078574',
    transition: '0.4s',
    borderRadius: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: '9px',
    fontSize: '12px',
    '&:before': {
      content: "''",
      position: 'absolute',
      height: '26px',
      width: '26px',
      left: '4px',
      bottom: '4px',
      transform: 'translateX(26px)',
      backgroundColor: 'white',
      transition: '0.4s',
      borderRadius: '30px',
      justifyContent: 'center',
    },
  },
};

export default styles;
